module.exports = __webpack_public_path__ + "static/media/odd5.75c73c15.jpg";